import React from "react";
import {
  ContactsOutlined,
  InstagramOutlined,
  SettingOutlined,
  SlackOutlined,
  UnorderedListOutlined,
  UserOutlined,
  WindowsOutlined,
  UploadOutlined,
  BankOutlined,
  ToolOutlined,
  ApartmentOutlined,
  OrderedListOutlined,
} from "@ant-design/icons";
import Dashboard from "../pages/Dashboard";
import Machines from "../pages/Machines";
import Users from '../pages/Users';
import ImageUpload from "../pages/Configurations/ImageUpload";
import Companies from '../pages/Company';
import Event from '../pages/Events';
import Session from '../pages/Sessions';
import Capabilities from '../pages/Capabilities';
import Roles from '../pages/Roles';
import Overrides from '../pages/Overrides';
import Resources from '../pages/Resources';
import Configurations from '../pages/Configurations';

export const SidebarData = [
  {
    title: "Dashboard",
    path: "/",
    icon: <SlackOutlined />,
    key: "1",
    component: Dashboard,
    role: ["user", "admin-platform"],
  },
  {
    title: "Users",
    path: "/users",
    icon: <UserOutlined />,
    key: "2",
    component: Users,
    role: ["admin-platform"],
  },
  {
    title: "Booths",
    path: "/machines",
    icon: <InstagramOutlined />,
    key: "4",
    component: Machines,
    role: ["utilisateur", "gerant"],
  },
  {
    title: "Events",
    path: "/events",
    icon: <UnorderedListOutlined />,
    key: "5",
    component: Event,
    role: ["user", "gerant"],
  },
  {
    title: "Sessions",
    path: "/sessions",
    icon: <WindowsOutlined />,
    key: "6",
    component: Session,
    role: ["user", "gerant"],
  },
  {
    title: "Configurations",
    path: "/configurations",
    icon: <SettingOutlined />,
    key: "7",
    component: Configurations,
    role: ["user", "gerant"],
  },
  {
    title: "Upload Pictures",
    path: "/upload-pictures",
    icon: <UploadOutlined />,
    key: "8",
    component: ImageUpload,
    role: ["user", "gerant"],
  },
  {
    title: "Companies",
    path: "/company",
    icon: <BankOutlined />,
    key: "9",
    component: Companies,
    role: ["admin-platform", "user"],
  },
  {
    title: "Resources",
    path: "/resources",
    icon: <ToolOutlined />,
    key: "10",
    component: Resources,
    role: ["admin-platform", "user"],
  },
  {
    title: "Capabilities",
    path: "/capabilities",
    icon: <ApartmentOutlined />,
    key: "11",
    component: Capabilities,
    role: ["admin-platform", "user"],
  },
  {
    title: "Overrides",
    path: "/overrides",
    icon: <OrderedListOutlined />,
    key: "12",
    component: Overrides,
    role: ["admin-platform", "user"],
  },
  {
    title: "Roles",
    path: "/roles",
    icon: <ContactsOutlined />,
    key: "13",
    component: Roles,
    role: ["admin-platform"],
  },
];
